export var Sizes = {
  FullScreen: 'MODAL/FULL_SCREEN',
  XxLarge: 'MODAL/XX_LARGE',
  XLarge: 'MODAL/X_LARGE',
  Large: 'MODAL/LARGE',
  Medium: 'MODAL/MEDIUM',
  Small: 'MODAL/SMALL'
};